const RESULTS_URL = 'https://resultados.novaimagemdiagnostico.com.br/portal/paciente_nova.html';

export function HeroSection() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="inicio" className="relative min-h-[600px] flex items-center justify-center overflow-hidden pt-20">
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-white to-teal-50"></div>

      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-10 w-72 h-72 bg-blue-400 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-teal-400 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 pb-4">
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="space-y-8 animate-fade-in">
            <div className="inline-flex items-center space-x-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-medium">
              <i className="ri-shield-check-line"></i>
              <span>Tecnologia de Ponta em Diagnóstico</span>
            </div>

            <h1 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-gray-900 leading-tight">
              Confiança e Cuidado em Cada Exame
            </h1>

            <p className="text-xl text-gray-600 leading-relaxed">
              Oferecemos exames com precisão, segurança e atenção em cada detalhe. Porque para nós, cuidar da sua saúde é mais do que um compromisso: é uma missão.
            </p>


            <div className="flex items-center gap-3 pt-2">
              <div>
                <div className="text-3xl font-bold text-blue-600">Mais de 20 anos de experiência</div>
                <div className="text-3xl font-bold text-blue-600">em exames</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <button
                onClick={() => window.open(RESULTS_URL, '_blank', 'noopener,noreferrer')}
                className="w-full sm:w-auto px-6 py-3 border-2 border-blue-600 text-blue-600 rounded-lg hover:bg-blue-600 hover:text-white transition-all font-medium cursor-pointer text-base"
              >
                Resultados de Exames
              </button>
              <button
                onClick={() => {
                  const element = document.getElementById('agendamento');
                  if (element) element.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-all font-medium shadow-lg hover:shadow-xl cursor-pointer text-base"
              >
                Agendar Exames
              </button>
            </div>
          </div>

          <div className="relative md:block hidden">
            <div className="relative w-full h-[600px] rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://static.readdy.ai/image/060e1c25caffef29cb7917b5a22faf7c/22cd9cd5a803b43ad98558b8da83ae45.png"
                alt="Equipamento moderno de diagnóstico por imagem"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-blue-900/20 to-transparent"></div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}
